// @ts-nocheck
import {useListView} from '../../core/ListViewProvider'
import {UsersListToolbar} from './UserListToolbar'
import {UsersListGrouping} from './UsersListGrouping'
import {UsersListSearchComponent} from './UsersListSearchComponent'

type SearchProps = {
  userSearch: String
  setUserSearch: Function
  loading?: boolean
  setLoading?: Function
  applyFilter?: boolean
  setApplyFilter?: Function
  bookingsData?: any[]
}

const UsersListHeader = ({
  genderFilter,
  setGenderFilter,
  userSearch,
  setUserSearch,
  setSDate,
  setEDate,
  sDate,
  eDate,
  page,
  setPage,
  loading,
  setLoading,
  applyFilter,
  setApplyFilter,
  bookingsData,
}: SearchProps) => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <UsersListSearchComponent userSearch={userSearch} setUserSearch={setUserSearch} />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? (
          <UsersListGrouping />
        ) : (
          <UsersListToolbar
            sDate={sDate}
            setSDate={setSDate}
            eDate={eDate}
            setEDate={setEDate}
            page={page}
            setPage={setPage}
            genderFilter={genderFilter}
            setGenderFilter={setGenderFilter}
            loading={loading}
            setLoading={setLoading}
            applyFilter={applyFilter}
            setApplyFilter={setApplyFilter}
            bookingsData={bookingsData}
          />
        )}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {UsersListHeader}
